
export interface IPopupDialogParametersInterface {
  header: string,
  subHeader?: string,
  imageUrl?: string,
  buttonOneText?: string,
  buttonTwoText?: string,
  textAreaValue?: string,
  buttonTopCloseShow?: boolean,
  textAreaPlaceholder?: string,
  buttonThreeText?: string,
  buttonThreeCallback?: Function,
  buttonOneCallback?: Function,
  buttonTwoCallback?: Function
  popupDialogShowThreeButtons?: boolean;
  navRoute?: string;
  callInsurerPopup?: boolean;
  contactList?: boolean;
  needToScroll?: boolean;
}
